import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { DialogComponent } from '../dialog/dialog.component';
import { Store } from '@ngrx/store';
import { Subject, lastValueFrom, takeUntil } from 'rxjs';
import { BodySendRFQs, Vendor } from 'src/app/shared/models/database-models';
import { BackendApiService } from 'src/app/core/services/backend-api';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MyPurchaseForm, UserInformation } from 'src/app/shared/models/app-models';
import { SecurityClassificationId } from '../../models/database-models/SecurityClassification';
import { FileService } from '../../services/file.service';
import { RfqOutputService } from 'src/app/modules/mypurchase-form/rfq-output/rfq-output.service';
@Component({
  selector: 'app-email-dialog',
  templateUrl: './email-dialog.component.html',
  styleUrls: ['./email-dialog.component.scss']
})
export class EmailDialogComponent implements OnInit  {
  vendorForm!: Vendor[];
  form!: MyPurchaseForm;
  destroy$: Subject<boolean> = new Subject<boolean>();
  mpNumber: string = '';
  loggedInUsername: string = '';
  disabled: boolean = false;
  constructor(
    public dialogInfoRef: MatDialogRef<DialogComponent>,
    private store: Store<{ form: MyPurchaseForm, user: UserInformation }>,
    private backEndService: BackendApiService,
    private _snackBar: MatSnackBar,
    private rfqOutputService: RfqOutputService,
    private fileService: FileService,
    ) {
      this.store.select('form').pipe(takeUntil(this.destroy$)).subscribe((form: MyPurchaseForm) => {
        this.form = form;
        this.vendorForm = form.VendorsToSource.filter(item => !item.isDeleted && !item.Strikethrough);
        this.mpNumber = form.documentNo || '';
      });
      this.store.select('user').pipe(takeUntil(this.destroy$)).subscribe((user: UserInformation) => {
        this.loggedInUsername = user.userName;
      })
    }
  ngOnInit(): void {
  }
  close(): void {
    this.dialogInfoRef.close();
  }
  async onEmail() {
    this.disabled = true;
    const VendorNumbers: string[] = this.vendorForm?.map(item => item.VendorNumber || '');
    const body: BodySendRFQs = {
      MPDocumentNumber: this.mpNumber,
      Vendors: VendorNumbers,
      User: this.loggedInUsername,
    }
    try {
      await lastValueFrom(this.backEndService.sendRFQs(body).pipe(takeUntil(this.destroy$)));
      this.openSnackBar('RFQ emailed');
    } catch (err) {
      this.openSnackBar('RFQ email failed to send.',"error");
    }
    this.disabled = false;
    this.dialogInfoRef.close();
  }

  async updateAndSendRFQ() {
    this.disabled = true;

    const newRFQDeadlines = this.rfqOutputService.newRFQDeadlines
    const affectedRFQNumbers = newRFQDeadlines.map(item => item.RFQNumber);

    const rfqBody = {
      MPDocumentNumber: this.mpNumber,
      RFQDeadline : this.form.RFQDeadline,
      vendorsList: this.vendorForm,
      actioner : this.loggedInUsername,
      rfqDeadlines: newRFQDeadlines
    }

    try {
      await lastValueFrom(
        this.backEndService.generateRFQ(rfqBody).pipe(takeUntil(this.destroy$))
      );
      this.openSnackBar('RFQ sent.');
    } catch (err) {
      this.openSnackBar('RFQ failed to send.', 'error');
    }

    let rfqOutput;
    try {
      // Refresh RFQ Output page data, and clear out any stored newRFQDeadline
      rfqOutput = await this.rfqOutputService.onFetchRfqOutput(this.mpNumber);
    } catch (err) {
      console.log(
        'Failed to re-fetch RFQ Output page data after updateAndSendRFQ',
        err
      );
    }

    const rfqItems = (rfqOutput?.data?.RFQ ?? []).filter(rfqItem => affectedRFQNumbers.includes(rfqItem.RFQNumber));

    try {
      // If MPDocument has high security classification, download RFQs generated as backend will not email RFQs out
      const externalId = this.form.generalForm?.external?.id ?? '';
      if (
        [
          SecurityClassificationId.RESTRICTED,
          SecurityClassificationId.CONFIDENTIAL,
          SecurityClassificationId.SECRET,
        ].includes(externalId as SecurityClassificationId)
      ) {

        if (rfqItems.length > 0) {
          const validUploadPaths = rfqItems
            .map((rfqItem) => rfqItem.UploadPath)
            .filter((str) => !!str) as string[];
          const uniqueUploadPaths = new Set(validUploadPaths);
          await this.fileService.downloadFiles(Array.from(uniqueUploadPaths), {
            isOpenInNewTab: true,
          });
        } else {
          console.log('updateAndSendRFQ did not trigger generated RFQs download as there are no affected RFQ Items', rfqItems);
        }
      }
    } catch (err) {
      console.log(err, rfqOutput, rfqItems);
      this.openSnackBar(
        'Error encountered while downloading the generated RFQs.',
        'error'
      );
    }

    this.disabled = false;
    this.dialogInfoRef.close();
  }

  openSnackBar(notifMsg: string, type: string = 'success') {
    this._snackBar.open(notifMsg, undefined, {
      verticalPosition: "top",
      panelClass: type == 'success' ? 'snackbar-popup' : 'app-notification-error',
      duration: 3000
    });
  }
}

